define(["exports", "../LinterRule", "../l10n"], function (_exports, _LinterRule, _l10n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.rule = void 0;
  _LinterRule = _interopRequireDefault(_LinterRule);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const name = "no-headingless-sections";
  const meta = {
    en: {
      description: "All sections must start with a `h2-6` element.",
      howToFix: "Add a `h2-6` to the offending section or use a `<div>`.",
      help: "See developer console."
    },
    nl: {
      description: "Alle secties moeten beginnen met een `h2-6` element.",
      howToFix: "Voeg een `h2-6` toe aan de conflicterende sectie of gebruik een `<div>`.",
      help: "Zie de developer console."
    }
  }; // Fall back to english, if language is missing

  const lang = _l10n.lang in meta ? _l10n.lang : "en";

  const hasNoHeading = ({
    firstElementChild: elem
  }) => {
    return elem === null || /^h[1-6]$/.test(elem.localName) === false;
  };
  /**
   * @param {*} _
   * @param {Document} doc
   * @return {import("../../core/LinterRule").LinterResult}
   */


  function linterFunction(_, doc) {
    const offendingElements = [...doc.querySelectorAll("section")].filter(hasNoHeading);

    if (!offendingElements.length) {
      return;
    }

    return _objectSpread({
      name,
      offendingElements,
      occurrences: offendingElements.length
    }, meta[lang]);
  }

  const rule = new _LinterRule.default(name, linterFunction);
  _exports.rule = rule;
});
//# sourceMappingURL=no-headingless-sections.js.map